<script>
    import { historyData, historyState } from "./stores";

    function back() {
        $historyData = [];
        $historyState = 0;
    }
    function getName(id) {
        if (id == 179 || id == 182 || id == 185) {
            return "SuntechnikChess";
        } else if (id == 180 || id == 181 || id == 184) {
            return "KhodjaNasreddin";
        }
        return "";
    }
</script>

<div>
    <button on:click={back}>Back</button>

    <p>Showing <b>1-20</b> of <b>20</b> items</p>
    <table>
        <thead>
            <tr>
                <th>#</th>
                <th>Game name</th>
                <th>Bet total</th>
                <th>Win total</th>
                <th>Balance after</th>
                <th>Started</th>
                <th>Finished</th>
            </tr>
        </thead>
        <tbody>
            {#each $historyData as row, i}
                <tr>
                    <td>{i + 1}</td>
                    <td>{getName(row.game_id)}</td>
                    <td>{(row.bet * row.lines * row.denomination) / 10}</td>
                    <td>{(row.win * row.denomination) / 10}</td>
                    <td>{row.balance_end / 10}</td>
                    <td
                        >{row.created_at.substr(11) +
                            "(+05:00) " +
                            row.created_at.substr(8, 2) +
                            "." +
                            row.created_at.substr(5, 2) +
                            "." +
                            row.created_at.substr(0, 4)}</td
                    >
                    <td
                        >{row.created_at.substr(11) +
                            "(+05:00) " +
                            row.created_at.substr(8, 2) +
                            "." +
                            row.created_at.substr(5, 2) +
                            "." +
                            row.created_at.substr(0, 4)}</td
                    >
                </tr>
            {/each}
        </tbody>
    </table>
</div>

<style>
    div {
        height: 100%;
        background-color: #fff;
        padding: 2rem;
    }
    table {
        width: 100%;
        border-collapse: collapse;
    }
    td,
    th {
        padding: 0.25rem 0.5rem;
        vertical-align: top;
        border: 1px solid #dee2e6;
    }
    button {
        display: inline-block;
        font-weight: 400;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        border: 1px solid #007bff;
        color: #fff;
        background-color: #007bff;
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: 0.25rem;
        transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
            border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }
    button:hover {
        color: #fff;
        background-color: #0069d9;
        border-color: #0062cc;
    }
</style>
